import { Box, Typography } from '@mui/material';
import { Styles } from 'common/types/styles';
import { MXAILogo } from 'common/ui/shared/mxai-logo';

const styles: Styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
    justifyContent: 'center',
    position: 'relative',
  },
  logoContainer: {
    position: 'absolute',
    top: 60,
    left: '50%',
    transform: 'translate(-50%, 0)',
  },
};

export function RuntimeError() {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.logoContainer}>
        <MXAILogo />
      </Box>
      <Typography variant="h3" color="GrayText">
        Something went wrong. Please, reload the page.
      </Typography>
    </Box>
  );
}
